import React from 'react';

const EmailSVG = ({ color = 'black', className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      className={className}
    >
      <path
        d="M15.4444 11C15.4444 13.4546 13.4546 15.4444 11 15.4444C8.5454 15.4444 6.55556 13.4546 6.55556 11C6.55556 8.5454 8.5454 6.55556 11 6.55556C13.4546 6.55556 15.4444 8.5454 15.4444 11ZM15.4444 11V12.6667C15.4444 14.2008 16.6881 15.4444 18.2222 15.4444C19.7563 15.4444 21 14.2008 21 12.6667V11C21 5.47716 16.5229 1 11 1C5.47716 1 1 5.47716 1 11C1 16.5229 5.47716 21 11 21H15.4444"
        stroke="#0744E1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmailSVG;
